import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Col, Container, Row } from "react-bootstrap";

class AdminDashboard extends Component {
  render() {
    return (
      <>
        <Container>
          <Row className="justify-content-lg-center">
            <Col>
              <h1>Admin Dashboard</h1>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row className="justify-content-lg-center">
            <Col>test</Col>
          </Row>
        </Container>
      </>
    );
  }
}

AdminDashboard.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(AdminDashboard);
